import { action } from "satcheljs";
import type { ActionMessage } from "satcheljs";
import type { DetailPaneContent, DetailPaneMailLoadErrorDetails } from "owa-personal-os-types";
import { getMailLoadErrorDetails } from "./getMailLoadErrorDetails";

export interface OnDetailPaneOpenedActionMessage extends ActionMessage {
    content: DetailPaneContent;
}

export const onDetailPaneOpened: (content: DetailPaneContent) => OnDetailPaneOpenedActionMessage = action("onDetailPaneOpened", (content: DetailPaneContent) => ({
    content,
}));

export const onDetailPaneClosed: () => ActionMessage = action("onDetailPaneClosed");

export interface OnDetailPaneMailLoadStartedActionMessage extends ActionMessage {
    contentId: string;
    loadId: number;
}

let nextDetailPaneMailLoadId = 0;

export const onDetailPaneMailLoadStarted: (contentId: string) => OnDetailPaneMailLoadStartedActionMessage = action("onDetailPaneMailLoadStarted", (contentId: string) => ({
    contentId,
    loadId: ++nextDetailPaneMailLoadId,
}));

export interface OnDetailPaneMailLoadFailedActionMessage extends ActionMessage {
    contentId: string;
    loadId: number;
    errorDetails: DetailPaneMailLoadErrorDetails;
}

export const onDetailPaneMailLoadFailed: (contentId: string, loadId: number, error: unknown) => OnDetailPaneMailLoadFailedActionMessage = action("onDetailPaneMailLoadFailed", (contentId: string, loadId: number, error: unknown) => ({
    contentId,
    loadId,
    errorDetails: getMailLoadErrorDetails(error),
}));
